import React from "react";
import { formatPrizeMoney, raceClassLabel } from "@/utils/race-cards";
import TickerText from "@/components/ui/ticker-text";

/**
 * Race details shown above the tips when Extra Details is on:
 * race name, prize money, 1st prize, class (or Group) and distance.
 * A race name too long for the panel slides like a ticker tape (tap resets).
 * @param {Object} card - one race from /api/race-cards
 */
export default function RaceInfoPanel({ card }) {
  if (!card) return null;

  const items = [
    {
      label: "Prize money",
      value: formatPrizeMoney(card.prizeMoney),
      bold: true,
    },
    { label: "1st prize", value: formatPrizeMoney(card.firstPrize) },
    { label: "Class", value: raceClassLabel(card) },
    { label: "Distance", value: card.distance ? `${card.distance}m` : null },
  ].filter((item) => item.value);

  if (items.length === 0 && !card.name) return null;

  return (
    <div
      className="race-info-panel mx-[0.4rem] mb-3 rounded-lg border border-gray-100 bg-gray-50 px-3 py-2"
      data-testid="race-info-panel"
    >
      {card.name && (
        <TickerText text={card.name} className="text-[11px] text-gray-600" />
      )}
      {items.length > 0 && (
        <dl
          className="mt-1.5 grid gap-2"
          style={{
            gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))`,
          }}
        >
          {items.map((item) => (
            <div key={item.label} className="flex min-w-0 flex-col gap-0.5">
              <dt className="text-[10px] text-gray-500">{item.label}</dt>
              <dd
                className={`truncate text-[13px] text-gray-900 tabular-nums ${item.bold ? "font-bold" : "font-semibold"}`}
              >
                {item.value}
              </dd>
            </div>
          ))}
        </dl>
      )}
    </div>
  );
}
